<template>
  <PreviewSheet class="cards-preview" radius="0">
    <div class="align-center flex-col justify-center gap-16">
      <PreviewTypography :text="content.params.title" variant="heading2" />
      <div class="cards-preview__grid">
        <CardsCard v-for="(card, index) in cards" :key="index" :card="card" />
      </div>
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

import type { CardsSection } from '../../../WebsiteBuilder.types'

import CardsCard from './CardsCard.vue'

const props = defineProps<{
  content: CardsSection
}>()

const cards = computed(() => {
  return props.content.params.cards
})
</script>

<style lang="scss" scoped>
.cards-preview {
  padding: 120px;

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;
  }
}
</style>
